export default "__VITE_ASSET__LRXMzpML__"